import { useContext } from 'react';
import { ScheduleContext } from './ScheduleContextValue';

export function useSchedule() {
  return useContext(ScheduleContext);
}
